import actions from '../../../constants/actionTypes';
import request from '../../../utils/request';
import { isSuccess } from '../../../utils/utils';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import { startAppLoading, stopAppLoading } from '../../../layout/actions';
import { trans } from '../../../localization';

export function getBankAccountNowPortal() {
  return dispatch =>
    request
      .getPortal('/wallet_in_merchant/bank_account/mine/')
      .then((response) => {
        if (isSuccess(response)) {
          dispatch({
            type: actions.RECEIVE_BANK_ACCOUNT_NOW_PORTAL,
            response: {
              bankAccount: response.reply.bank_account,
            },
          });
        }
      });
}

export function getBalanceNowPortal() {
  return dispatch =>
    request.getPortal('/wallet_in_merchant/balance/').then((response) => {
      if (isSuccess(response)) {
        dispatch({
          type: actions.RECEIVE_BALANCE_NOW_PORTAL,
          response: {
            balance: response.reply,
          },
        });
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
    });
}

export function getBankTransferNowPortal() {
  return dispatch =>
    request
      .getPortal('/wallet_in_merchant/bank_account/config/')
      .then((response) => {
        if (isSuccess(response)) {
          dispatch({
            type: actions.RECEIVE_BANK_TRANSFER_NOW_PORTAL,
            response: {
              bankTransfer: response.reply.bank_transfer,
            },
          });
        } else {
          dispatch(setGeneralError(trans(response.result)));
        }
      });
}

export function getListBankNowPortal() {
  return dispatch =>
    request.getPortal('/wallet_in_merchant/bank/').then((response) => {
      if (isSuccess(response)) {
        dispatch({
          type: actions.RECEIVE_LIST_BANK_NOW_PORTAL,
          response: {
            banks: response.reply.results,
          },
        });
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
    });
}

export function getListProvinceNowPortal(bankId) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .getPortal(`/wallet_in_merchant/bank/${bankId}/province/`)
      .then((response) => {
        if (isSuccess(response)) {
          dispatch(stopAppLoading());
          return response.reply.results;
        }
        dispatch(setGeneralError(trans(response.result)));
        dispatch(stopAppLoading());
        return {};
      });
  };
}

export function getListOfficeNowPortal(bankId, provinceId) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .getPortal(
        `/wallet_in_merchant/bank/${bankId}/province/${provinceId}/office/`,
      )
      .then((response) => {
        if (isSuccess(response)) {
          dispatch(stopAppLoading());
          return response.reply.results;
        }
        dispatch(setGeneralError(trans(response.result)));
        dispatch(stopAppLoading());
        return {};
      });
  };
}

export function applyNewBankAccount(reqParams, otp) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .postPortal(
        '/wallet_in_merchant/bank_account/',
        reqParams,
        otp ? { 'NWM-Otp': otp } : undefined,
      )
      .then(async (response) => {
        if (!otp && response.result === 'error_need_otp') {
          dispatch(stopAppLoading());
          return true;
        }
        if (isSuccess(response)) {
          await dispatch(getBankAccountNowPortal());
          dispatch(stopAppLoading());
          return true;
        }
        dispatch(setGeneralError(trans(response.result)));
        dispatch(stopAppLoading());
        return false;
      });
  };
}

export function removeBankAccount() {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .deletePortal('/wallet_in_merchant/bank_account/deactivate/')
      .then((response) => {
        if (isSuccess(response)) {
          dispatch(stopAppLoading());
          dispatch({
            type: actions.RECEIVE_BANK_ACCOUNT_NOW_PORTAL,
            response: {
              bankAccount: {},
            },
          });
          return true;
        }
        dispatch(setGeneralError(trans(response.result)));
        dispatch(stopAppLoading());
        return false;
      });
  };
}

export function enableAutoTransfer(options, otp) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .postPortal(
        '/wallet_in_merchant/bank_account/auto_transfer/enable/',
        options,
        otp ? { 'NWM-Otp': otp } : undefined,
      )
      .then(async (response) => {
        if (!otp && response.result === 'error_need_otp') {
          dispatch(stopAppLoading());
          return true;
        }
        if (isSuccess(response)) {
          await dispatch(getBankTransferNowPortal());
          dispatch(stopAppLoading());
          return true;
        }
        dispatch(setGeneralError(trans(response.result)));
        dispatch(stopAppLoading());
        return false;
      });
  };
}

export function disableAutoTransfer() {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .postPortal('/wallet_in_merchant/bank_account/auto_transfer/disable/')
      .then(async (response) => {
        if (isSuccess(response)) {
          await dispatch(getBankTransferNowPortal());
          dispatch(stopAppLoading());
          return true;
        }
        dispatch(setGeneralError(trans(response.result)));
        dispatch(stopAppLoading());
        return false;
      });
  };
}

export function requestWithdrawNowPortal(bankAccountId, amount, otp) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request
      .postPortal(
        '/wallet_in_merchant/bank_account/withdraw/',
        {
          bank_account_id: bankAccountId,
          amount,
        },
        otp ? { 'NWM-Otp': otp } : undefined,
      )
      .then((response) => {
        if (!otp && response.result === 'error_need_otp') {
          dispatch(stopAppLoading());
          return true;
        }
        if (isSuccess(response)) {
          dispatch(stopAppLoading());
          return true;
        }
        dispatch(stopAppLoading());
        return false;
      });
  };
}

export function initWithdrawNowPortal() {
  return (dispatch) => {
    dispatch(startAppLoading());
    Promise.all([
      dispatch(getBankAccountNowPortal()),
      dispatch(getBalanceNowPortal()),
      dispatch(getListBankNowPortal()),
      dispatch(getBankTransferNowPortal()),
    ]).then(() => {
      dispatch(stopAppLoading());
    });
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalWithdraw/actions.js